import { Component, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { select, Store } from "@ngrx/store";
import { Observable, takeUntil } from "rxjs";
import { BaseComponent } from "src/app/base.component";
import { VideoAdComponent } from "src/app/shared/components/video-ad/video-ad.component";
import { AdvertisingCampaignInterface } from "src/app/shared/models/advertising-campaigns/advertising-campaign.interface";
import { IColumn } from "src/app/shared/models/table/column.interface";
import { BadgeService } from "src/app/shared/services/badge.service";
import { JwtService } from "src/app/shared/services/jwt.service";
import { advertisingCampaignSelector } from "src/app/store/advertisingCampaign/advertiserCampaign.selectors";
import { invokeLatestAdvertisingCampaigns } from "src/app/store/advertisingCampaign/advertisingCampaign.actions";
import { AppStateInterface } from "src/app/store/appState.interface";
import { invokeFranchisedCompanyNamesByFranchise } from "src/app/store/franchise/franchise.action";
import { resultFranchisedCompanyNamesByFranchiseSelector } from "src/app/store/franchise/franchise.selectors";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-latest-advertising-campaigns",
  templateUrl: "./latest-advertising-campaigns.component.html",
})
export class LatestAdvertisingCampaignsComponent
  extends BaseComponent
  implements OnInit
{
  columns: IColumn[] = [
    {
      key: "nomCampagne",
      label: "campaignDetails.campaignName",
      sorter: true,
    },
    {
      key: "Date de début",
      label: "campaignDetails.startDate",
      sorter: true,
    },
    {
      key: "Date de fin",
      label: "campaignDetails.endDate",
      sorter: false,
    },
    {
      key: "Impressions",
      label: "campaignDetails.impressions",
      sorter: true,
    },
    {
      key: "location",
      label: "campaignDetails.location",
      sorter: true,
    },
    {
      key: "Statut",
      label: "campaignDetails.status",
      sorter: true,
    },
  ];
  advertisingCampaign$: Observable<AdvertisingCampaignInterface[] | null>;
  advertisingCampaign: AdvertisingCampaignInterface[] = [];
  loading: boolean = true;

  listFranchised$: Observable<string[]>;
  listFranchised: string[] = [];
  companyName: string;
  constructor(
    private modalService: NgbModal,
    public badgeService: BadgeService,
    private store: Store<AppStateInterface>,
    private jwtService: JwtService
  ) {
    super(store);
    this.advertisingCampaign$ = this.store
      .pipe(select(advertisingCampaignSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.listFranchised$ = this.store
      .pipe(select(resultFranchisedCompanyNamesByFranchiseSelector))
      .pipe(takeUntil(this.ngDestroyed$));
    this.companyName = jwtService.getCompanyName();
  }

  ngOnInit(): void {
    this.store.dispatch(
      invokeFranchisedCompanyNamesByFranchise({ companyName: this.companyName })
    );
    this.listFranchised$.subscribe((result) => {
      if (result) {
        this.listFranchised = result;
      }
    });
    this.store.dispatch(invokeLatestAdvertisingCampaigns());
    this.advertisingCampaign$.subscribe(
      (result: AdvertisingCampaignInterface[] | null) => {
        if (result != null) {
          this.loading = false;
          this.advertisingCampaign = result;
        }
      }
    );
  }

  onClickShowModal(videoLink: string) {
    const modalRef = this.modalService.open(VideoAdComponent, {
      size: "lg",
      centered: true,
    });
    modalRef.componentInstance.closeTheModal.subscribe((value: boolean) =>
      modalRef.close()
    );
    modalRef.componentInstance.videoLink = environment.CDN_RELEAD + videoLink;
  }

  filterFranchisedLocationPartners(locationPartners: string[]): string[] {
    return locationPartners.filter((lp) =>
      this.listFranchised.some((franchised) => franchised === lp)
    );
  }
}
